<div class="modal-header custom-header">
  <h4 class="modal-title custom-color">
    {{ mode === 'refund' ? ('company.transaction.filters.type-refund' | translate) : ('company.transaction.filters.type-payment' | translate) }}
  </h4>
</div>

<div class="modal-body" style="padding: 2rem;">
  <div *ngFor="let booked of bookeds" class="mb-3 border-bottom pb-3">
  <div class="d-flex" style="gap: 2rem;">
    <p><strong>{{ 'common.flight' | translate }}:</strong> {{ booked.from }} - {{ booked.to }}</p>
    <p *ngIf="type === 'train' ? booked.price !== undefined : booked.price?.individualPrice !== undefined">
      <strong>{{ 'flight.detail-flight.current-price' | translate }}:</strong>
      {{
        (type === 'train'
          ? booked.price
          : booked.price?.individualPrice) | number:'1.2-2'
      }} €
    </p>
  </div>
  
  <p *ngIf="booked.extraInfo?.length > 0 && booked.extraInfo[0]?.passengerName">
    <strong>{{ 'flight.form-flight.passenger' | translate }}:</strong> {{ booked.extraInfo[0].passengerName }}
  </p>

    <input
      type="number"
      class="form-control"
      [placeholder]="mode === 'refund' ? 'Importe a devolver' : 'Importe a pagar'"
      (input)="updateAmount(booked.uuid, $event.target.value)"
      [disabled]="mode === 'refund' && ((type === 'train' && booked.price === 0) || (type !== 'train' && booked.price?.individualPrice === 0))"
    />
  </div>
  <p class="mt-3 font-weight-bold text-right">
  {{ 'csv.total' | translate }}: {{ totalEntered | number:'1.2-2' }} / {{ maxAmount | number:'1.2-2' }} €
  </p>
</div>

<div class="modal-footer" style="padding: 1.5rem;">
  <button class="btn btn-secondary" (click)="cancel()">{{ 'common.cancel' | translate }}</button>
  <button
    class="btn btn-primary"
    style="color: white !important;"
    [disabled]="(mode === 'refund' && totalEntered > maxAmount) || totalEntered <= 0 || invalidAmounts"
    (click)="confirm()"
  >
    {{ 'common.confirm' | translate }}
  </button>
</div>
